import api from "api/axios";


export const getScanners = (params) =>
  api.post("/scanners/search", params);

export const getScannerById = (id) =>
  api.get(`/scanners/${id}`);

export const createScanner = (payload) =>
  api.post("/scanners/", payload);

export const updateScanner = (id, payload) =>
  api.put(`/scanners/${id}`, payload);

export const deleteScanner = (id, payload) =>
  api.delete(`/scanners/${id}`, { data: payload })

export const getScannerLoginLogs = (payload) =>
    api.post(`/scanners/login-logs`, payload);

export const getScanLogs = (payload) =>
    api.post(`/scanners/scan-logs`, payload);

export const forceLogout = (scannerId) =>
  api.post(`/scanners/${scannerId}/force-logout`);
